import { Component } from '@angular/core';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss']
})
export class AdminPageComponent {
/**
 *
 */
constructor(public cm: ConnectionManagerService) {
  
  
}
}
